var render, staticRenderFns
import script from "./LinkTile.vue?vue&type=script&lang=js&"
export * from "./LinkTile.vue?vue&type=script&lang=js&"
import style0 from "./LinkTile.vue?vue&type=style&index=0&id=3ba56b4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports